import { ANALYTICS_IMAGE_SCROLLED } from "./constants";
import { createAction } from "@reduxjs/toolkit";

export const analyticsScrollImage = createAction(ANALYTICS_IMAGE_SCROLLED);
